import React from "react"
import { Link, useStaticQuery, graphql } from 'gatsby'
import { GatsbyImage } from "gatsby-plugin-image";

import * as recentBlogStyles from './recentBlog.module.scss'

const RecentBlog = () => {
    const data = useStaticQuery(graphql`
        query {
            allContentfulBlogPost ( 
                sort: {publishedDate: DESC},
                limit: 6) 
                {
                edges {
                    node {
                        blogTitle
                        subtitle
                        slug
                        category {
                            name
                            slug
                        }
                        thumbnailImage {
                            imgixImage {
                                gatsbyImageData (width: 800, imgixParams: {q: 75, crop: "entropy", mark: "https://images.ctfassets.net/092wi7ilt2cf/VuXICYpBbTAFCyAiphn1b/c09048a06d3e8836732dc6affb9c9c44/logo_small_color.png"})
                              }
                            description
                        }
                    }
                }
            }
    
        }
    `)

    return (
        <div>
            <div className={recentBlogStyles.container}>
                <h2 className={recentBlogStyles.heading}>Explore</h2>
                <h3 className={recentBlogStyles.subheading}>My latest journeys</h3>
                <div className={recentBlogStyles.blogs}>
                {data.allContentfulBlogPost.edges.map((edge) => {
                        return (
                            <Link key={edge.node.slug} className={recentBlogStyles.blogBlock} to={`/${edge.node.category[0].slug}/${edge.node.slug}`}>
                                <div className={recentBlogStyles.thumbnailBlock}>
                                    <GatsbyImage
                                        image={edge.node.thumbnailImage.imgixImage.gatsbyImageData}
                                        className={recentBlogStyles.thumbnail}
                                        alt={edge.node.thumbnailImage.description} />
                                    <div className={recentBlogStyles.thumbnailOverlay}></div>
                                
                                </div>
                                <div className={recentBlogStyles.textBox}>
                                    <div className={recentBlogStyles.textBoxOverlay}></div>
                                    <p className={recentBlogStyles.category}>{edge.node.category[0].name}</p>
                                    <h4 className={recentBlogStyles.blogTitle}>{edge.node.blogTitle}</h4>
                                    <h5 className={recentBlogStyles.subtitle}>{edge.node.subtitle}</h5>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default RecentBlog